// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"48acd0f2","453":"ac884ddd","678":"b87a37a5","716":"a24d4efe","823":"8df198db"}[chunkId] + ".chunk.js";
};